import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown, Menu, X, ArrowUpRight } from 'lucide-react';
import Logo from '../assets/Photos/s-logo.png';
import { services } from '../data/services';
export default function Navbar() {
  const [mobile, setMobile] = useState(false),
    [open, setOpen] = useState(false);
  const ref = useRef(null);
  const location = useLocation();
  useEffect(() => {
    setMobile(false);
    setOpen(false);
  }, [location.pathname]);
  useEffect(() => {
    const close = e => {
      if (!ref.current?.contains(e.target)) {
        setOpen(false);
        setMobile(false);
      }
      if (e.key === 'Escape') {
        setOpen(false);
        setMobile(false);
      }
    };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', close);
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('keydown', close);
    };
  }, []);
  return <><a className="skip-link" href="#main-content">Skip to content</a><header className="site-header" ref={ref}><nav className="home-wrap nav-inner" aria-label="Main navigation"><Link to="/" aria-label="Sync Strategic home"><img src={Logo} alt="Sync Strategic" /></Link><button className="mobile-toggle" aria-label={mobile ? 'Close menu' : 'Open menu'} aria-expanded={mobile} aria-controls="main-navigation" onClick={() => setMobile(!mobile)}>{mobile ? <X /> : <Menu />}</button><div id="main-navigation" className={`nav-links ${mobile ? 'is-open' : ''}`}><div className="services-nav"><div className="services-nav-label"><Link to="/services">Services</Link><button aria-label="Toggle services submenu" aria-expanded={open} aria-controls="service-submenu" onClick={() => setOpen(!open)}><ChevronDown size={16} /></button></div>{open && <div id="service-submenu" className="service-submenu">{services.map(s => <Link to={`/services/${s.slug}`} key={s.slug}><strong>{s.name}</strong><span>{s.benefit}</span></Link>)}</div>}</div><Link to="/sync-framework">SYNC Framework</Link><Link to="/about">About</Link><Link to="/insights">Insights</Link><Link className="nav-contact" to="/contact">Let’s Talk <ArrowUpRight size={16} /></Link></div></nav></header></>;
}
